module.exports = __webpack_public_path__ + "img/banner1.d1042f82.png";